import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: Home,
  //   meta: {
  //     layout: "main"
  //   }
  // },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/NewHome.vue'),
    meta: {
      layout: "newmain",
      type: "overview"
    },
  },
  {
    path: '/mycourse',
    name: 'my_course',
    component: () => import('../views/NewMyCourse.vue'),
    meta: {
      layout: "newmain",
      type: "mycourse",
    },
  }, ,
  {
    path: '/course',
    name: 'course',
    component: () => import('../views/NewCourseList.vue'),
    meta: {
      layout: "newmain",
      type: "course",
    },
  },
  {
    path: '/instructor/:id',
    name: 'instructor',
    component: () => import('../views/newInstructor.vue'),
    meta: {
      layout: "newmain",
      type: "instructor",
    },
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('../views/Portfolio.vue'),
    meta: {
      layout: "newmain"
    },
  },
  {
    path: '/instructors',
    name: 'instructors',
    component: () => import('../views/RecommendInstructor.vue'),
    meta: {
      layout: "newmain"
    },
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('../views/Category.vue'),
    meta: {
      layout: "newmain"
    },
  },
  // {
  //   path: '/course_old',
  //   name: 'course',
  //   component: () => import('../views/CourseList.vue'),
  //   meta: {
  //     layout: "main"
  //   },
  // },
  {
    path: '/course/:id',
    name: 'course_detail',
    // component: () => import('../views/CourseDetail.vue'),
    component: () => import('../views/NewCourseDetail.vue'),
    meta: {
      layout: "newmain"
    },
  },
  {
    path: '/player',
    name: 'player',
    component: () => import('../views/CoursePlayer.vue'),
    meta: {
      layout: "newmain"
    },
  },
  {
    path: '/wishlist',
    name: 'wishlist',
    component: () => import('../views/NewWishList.vue'),
    meta: {
      layout: "newmain"
    },
  },
  // {
  //   path: '/mycourse',
  //   name: 'my_course',
  //   component: () => import('../views/MyCourse.vue'),
  //   meta: {
  //     layout: "newmain"
  //   },
  // },
  {
    path: '/myidentity',
    name: 'my_identity',
    component: () => import('../views/MyIdentity.vue'),
    meta: {
      layout: "newmain"
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/newUserProfile.vue'),
    meta: {
      layout: "newmain",
      type: "setting",
    },
  },
  // {
  //   path: '/profile',
  //   name: 'profile',
  //   component: () => import('../views/UserProfile.vue'),
  //   meta: {
  //     layout: "newmain",
  //     type: "setting",
  //   },
  // },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/SearchResult.vue'),
    meta: {
      layout: "newmain",
      type: "search",
    },
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('../views/Login_new.vue'),
  //   meta: {
  //     layout: "full-page"
  //   }
  // },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('../views/EventManagement.vue'),
    meta: {
      layout: "newmain",
      type: "notification",
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => {
      const host = window.location.host;
      const parts = host.split(".");
      let subDomain = "";

      if(host.indexOf("clsedo") > -1){
        subDomain = "clsedo"  //support culionline.com = culionline.nerdof.com
      } else if(host.indexOf("culionline") > -1){
        subDomain = "culionline"  //support culionline.com = culionline.nerdof.com
      } else if ((parts[0] == 'nerdof' || parts[0] == "beta" || parts[0] == 'www' || parts[0] == 'home' || parts[0] == 'app' || (parts.length == 2 && host.indexOf("localhost") == -1))) { // www.nerdof.com, nerdof.com, vknows.co , subdomain.com
        console.log(parts[0])
        return import('../views/Login_new.vue');
      } else if (parts.length >= 3) {  // subdomain.nerdof.com, subdomain.vknows.com
        console.log(parts[0],parts[1])
        subDomain = parts[0];
      } else if (host.indexOf("localhost") > -1 && parts.length > 1 && parts[0] !== "localhost") {
        subDomain = parts[0];
      } else {
        return import('../views/Login_new.vue');
      }
      if (subDomain.length > 0) {
        switch (subDomain) {
          case "lms":
            return import('../views/Login_new.vue');
          case "culionline":
            return import('../views/LoginBySubDomain.vue');
          case "test":
            return import('../views/Login_new.vue');
          default:
            return import('../views/LoginBySubDomain.vue');
          // กรณียังไม่เอา subdomain
          // return import('../views/Login_new.vue');
        }
      } else {
        return import('../views/Login_new.vue')
      }
    },
    meta: {
      layout: "full-page"
    }
  },
  // {
  //   path: '/loginnew',
  //   name: 'login',
  //   component: () => import('../views/Login_new.vue'),
  //   meta: {
  //     layout: "full-page"
  //   }
  // },
  {
    path: '/login-by-subdomain',
    name: 'loginBySubDomain',
    component: () => import('../views/LoginBySubDomain.vue'),
    meta: {
      layout: "full-page"
    }
  },
  {
    path: '/classroom/:id',
    name: 'classroom',
    component: () => import('../views/classroom/Course.vue'),
    meta: {
      layout: "newmain",
      isClassRoom: true
    },
  },
  {
    path: '/live/:id',
    name: 'live',
    component: () => import('../views/classroom/Live.vue'),
    meta: {
      layout: "newmain",
      isClassRoom: true
    },
  },
  {
    path: '/signup',
    name: 'register',
    component: () => import('../views/register.vue'),
    meta: {
      layout: "full-page"
    }
  },
  // {
  //   path: '/discussion/:id',
  //   name: 'discussion',
  //   component: () => import('../views/DiscussionBoard.vue'),
  //   meta: {
  //     layout: "newmain"
  //   },
  // },
  {
    path: '/discussion/:id',
    name: 'discussion',
    component: () => import('../views/newDiscussionBoard/DiscussionBoard.vue'),
    meta: {
      layout: "newmain"
    },
  },
  {
    path: '/',
    redirect: { path: '/home' },
  },
  {
    path: '*',
    redirect: { path: '/home' },
  },
]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
